import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64fba246"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "head-menu" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Radwegering")
const _hoisted_3 = { class: "buttons desktop-only" }
const _hoisted_4 = ["onClick", "to"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ion_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMobileMenu())),
      class: "mobile-only",
      color: "light"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_icon, { icon: _ctx.menu }, null, 8, ["icon"])
      ]),
      _: 1
    }),
    _createElementVNode("h1", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/'))),
      class: "clickable"
    }, [
      _createVNode(_component_ion_icon, {
        class: "desktop-only",
        icon: _ctx.bicycleOutline
      }, null, 8, ["icon"]),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.NavigationList.filter(e => !e.mobileOnly), (nav) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass({'btn-12': true, 'selected': _ctx.$router.currentRoute.value.fullPath === nav.url}),
          onClick: ($event: any) => (_ctx.$router.push(nav.url)),
          key: nav.url,
          to: nav.url
        }, _toDisplayString(nav.label), 11, _hoisted_4))
      }), 128))
    ])
  ]))
}